/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_PAYMENT_QUEUE } from "../graphql";
import { VApplication } from "../../../application";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import moment from "moment";
import {
  AppServiceMachineType,
  AppServiceRequestProcessor,
} from "../../state-machine";
import { ProcessQResponseMessage } from "../messages";
import { PROCESS_PAYMENT_Q_RESPONSE } from "../machines/process-payment-q-response";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();
const distCenterData = storageService.get("distCenterData", "local");
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IPaymentQueueMethods extends IPluginMethodMap {
  getPaymentQueue(args: any): Promise<any>;
}

export class PaymentQueueService
  extends AppServiceRequestProcessor
  implements IAgentPlugin
{
  readonly methods: IPaymentQueueMethods;

  constructor() {
    super();
    this.methods = {
      getPaymentQueue: this.getPaymentQueue.bind(this),
    };
  }

  async getPaymentQueue(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    //return {...(config)}
    console.log(`distCenterData in payment service`, distCenterData);
    try {
      if (client) {
        const res = await client.query({
          query: GET_PAYMENT_QUEUE,
          variables: {
            distCenter: {
              _id: distCenterData?.distCenter,
            },
            queueType: "distribution",
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          const _data = this.preFormatData(res?.data?.getQueueFromVQMS?.parsed);
          console.log(`payment queue data`, _data);
          const msg = await this.processQResponseMachine(_data);
          log.blue(`msg in payment service`, msg);
          if (msg?.raw) {
            delete msg.raw;
          }
          return msg;
        }
      }
    } catch (err: any) {
      console.log(`error in processQResponseMachine =>`, err?.message);
      throw err;
    }
    // return {...(config || {})}
  }

  private preFormatData(data: any) {
    let currentCounter = distCenterData?.paymentCounter;
    let _res: any[] = [];
    data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: any) => {
        if (item?.lockedByDistCounter === currentCounter) {
          _res.push({ ...item });
        }
      });
    return { parsed: _res };
  }

  private async processQResponseMachine(raw: any) {
    try {
      const machineType = AppServiceMachineType.PROCESS_PAYMENT_Q_RESPONSE;
      const message = new ProcessQResponseMessage({
        raw: raw,
      });
      await this.startProcessing({
        machineType: machineType,
        machineConfig: PROCESS_PAYMENT_Q_RESPONSE?.extendContextWith({
          message: message,
        }),
      });
      console.log("SM outputted message", message);
      return message;
    } catch (e: any) {
      log.error(`Error in handleW3CMessage =>`, e);
      throw e;
    }
  }
}
